module.exports = __webpack_public_path__ + "static/media/sanguo-4.19c6e7cc.png";